
    import { Mapper } from "../../../../base/utils/mapper";
    import { ExplorationNeurologyResponseModel } from "../../../../domain/models/consult/exploration-neurology-response.model";
    import { ExplorationNeurologyResponseEntity } from "../entities/exploration-neurology-response.entity";
    export class ExplorationNeurologyImplementationRepositoryRepositoryMapper extends Mapper<ExplorationNeurologyResponseEntity, ExplorationNeurologyResponseModel>{
        mapFrom(param:  ExplorationNeurologyResponseEntity):  ExplorationNeurologyResponseModel { 
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors
            }; 
        }
        mapTo(param:  ExplorationNeurologyResponseModel):  ExplorationNeurologyResponseEntity {
            return {
                data:param.data,
                isSuccess:param.isSuccess,
                message:param.message,
                errors:param.errors 
            };
        }
    }